import React, { Component } from 'react'
import style from '../style.module.less'

export default class extends Component {
  render() {
    return (
      <div className={style.describe}>
        <img src="//qnm.hunliji.com/o_1daogsc7p13q6joj1lcm10vo1rdfe.png?imageView2/2/w/240" />
        <div className={style.content}>
          <h4>视频直播</h4>
          <p>
            视频直播是针对平台商家在线进行店铺服务或内容直播，通过真实、生动的传播，营造出强烈的现场感，吸引用户眼球，能够真实、直观、全面的宣传、展示自己店铺服务及内容，挖掘潜在客资，快速打造线上品牌及口碑，通过视频直播的影响力转化一定客资。
          </p>
        </div>
      </div>
    )
  }
}
